export enum ModalType {
    CENTER = 'modal_centered',
    SIDE = 'modal_side'
}